module.exports = __webpack_public_path__ + "97e72ca8a95c53c50bec36bd37582c90.pdf";